export default "__VITE_ASSET__D8VDb6wo__"